import Swiper, { Autoplay, EffectFade } from "swiper";
Swiper.use([ Autoplay, EffectFade ])

export default class About {
  constructor (el) {
    this.el = el
    this.slider = null
  }

  init () {
    this.slider = new Swiper(this.el, {
      slidesPerView: 1,
      effect: 'fade',
      simulateTouch: false,
      allowTouchMove: false,
      speed: 1000,
      autoplay: {
        delay: 3000
      },
      fadeEffect: {
        crossFade: true
      }
    })
  }
}
